<template>
  <Teleport to="body">
    <div class="notify-container" aria-live="polite">
      <transition-group name="notify-slide">
        <div
          v-for="n in notifications"
          :key="n.id"
          class="notify-toast"
          :class="`notify-${n.type}`"
        >
          <div class="notify-icon">
            <i :class="iconClass(n.type)"></i>
          </div>
          <div class="notify-body">{{ n.message }}</div>
          <button class="notify-close" @click="dismiss(n.id)">&times;</button>
        </div>
      </transition-group>
    </div>
  </Teleport>
</template>

<script setup>
import { useNotify } from '@/composables/useNotify';

const { notifications } = useNotify();

function iconClass(type) {
  const map = {
    success: 'ri-checkbox-circle-fill',
    danger: 'ri-error-warning-fill',
    warning: 'ri-alert-fill',
    info: 'ri-information-fill',
  };
  return map[type] || map.info;
}

function dismiss(id) {
  const idx = notifications.findIndex(n => n.id === id);
  if (idx > -1) notifications.splice(idx, 1);
}
</script>

<style scoped>
.notify-container {
  position: fixed;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 480px;
  width: calc(100% - 32px);
  pointer-events: none;
}

.notify-toast {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  pointer-events: auto;
  backdrop-filter: blur(8px);
  animation: notify-in 0.3s ease;
}

.notify-icon {
  font-size: 20px;
  margin-left: 12px;
  flex-shrink: 0;
}

.notify-body {
  flex-grow: 1;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
}

.notify-close {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  opacity: 0.6;
  padding: 0 4px;
  margin-right: 4px;
  flex-shrink: 0;
}

.notify-close:hover { opacity: 1; }

/* Types */
.notify-success {
  background: rgba(10, 179, 156, 0.95);
  color: #fff;
}

.notify-danger {
  background: rgba(240, 101, 72, 0.95);
  color: #fff;
}

.notify-warning {
  background: rgba(247, 184, 75, 0.95);
  color: #333;
}

.notify-info {
  background: rgba(41, 156, 219, 0.95);
  color: #fff;
}

/* Transitions */
.notify-slide-enter-active {
  transition: all 0.3s ease;
}
.notify-slide-leave-active {
  transition: all 0.25s ease;
}
.notify-slide-enter-from {
  opacity: 0;
  transform: translateY(-20px);
}
.notify-slide-leave-to {
  opacity: 0;
  transform: translateX(40px);
}

@keyframes notify-in {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
